<template>
  <div class="ranking-outer">
    <BlockTitle title="资产排名"/>
    <div class="table-outer">
      <div class="table-head">
        <div class="cell">排名</div>
        <div class="cell">区域</div>
        <div class="cell">数量（个）</div>
      </div>
      <div class="table-body">
        <div class="row" v-for="(item,index) in rankingList" :key="index">
          <div class="cell" >
            <div></div><img v-if="index <= 2" :src="rankIcon(index)" alt="" />
            <div v-else>{{index+1}}</div>
          </div>
          <div class="cell" :title="item.locName">{{item.locName}}</div>
          <div class="cell" >{{item.cnt}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockTitle from '@/views/public_0983cc/tradeData/components/public/BlockTitle.vue'
import { data_v2_ranking } from '@/api/portal'
import { mapGetters } from 'vuex'

export default {
  components:{
    BlockTitle
  },
  data(){
    return {
      rankingList:[]
    }
  },
  computed:{
    ...mapGetters(['selectLocId']),
    rankIcon(){
      return function(ranking){
        return require(`@/assets/images/排名${ranking+1}.png`)
      }
    },
    isEven(){
      return function(index){
        return index % 2 === 0
      }
    }
  },
  watch:{
    selectLocId(){
      this.getRanking()
    }
  },
  created(){
    this.getRanking()
  },
  methods:{
    // 获取排名
    async getRanking(){
      //let {data} = await data_v2_ranking({locId:this.selectLocId})
      this.rankingList = [
        {
            "id":1,
            "locName": "乳源瑶族自治县",
            "cnt": 60140,
        },
        {
            "id":2,
            "locName": "新丰县",
            "cnt": 13672,
        },
        {
            "id":3,
            "locName": "乐昌市",
            "cnt": 10272,
        },
        {
            "id":4,
            "locName": "曲江区",
            "cnt": 5812,
        },
        {
            "id":5,
            "locName": "南雄市",
            "cnt": 4491,
        },
        {
            "id":6,
            "locName": "翁源县",
            "cnt": 3608,
        },
        {
            "id":7,
            "locName": "武江区",
            "cnt": 2623,
        },
        {
            "id":8,
            "locName": "仁化县",
            "cnt": 2530,
        },
        {
            "id":9,
            "locName": "始兴县",
            "cnt": 2156,
        },
        {
            "id":10,
            "locName": "浈江区",
            "cnt": 1614,
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .block-title-outer .title{
    height: auto;
  }
}
.ranking-outer{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.table-outer{
  height: 100%;
  color: #fff;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #15AEFF;
  }
  &::-webkit-scrollbar-track{
    background-color: #01174D;
  }
  .cell{
    height: 38px;
    line-height: 38px;
  }
  .table-head{
    display: flex;
    justify-content: space-between;
    color: rgba($color: #fff, $alpha: .9);
    font-size: 16px;
    padding-bottom: 7px;
    margin-bottom: 7px;
    border-bottom: 2px solid #00468A;
    .cell{
      flex: 1;
      text-align: center;
    }
  }
  .table-body{
    overflow-y: auto;
    height: 200px;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-thumb{
      background-color: var(--color);
    }
    &::-webkit-scrollbar-track{
      background-color: #01174D;
    }
    .row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .cell{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex: 1;
        text-align: center;
      }
      &.zebra{
        background-color: #00468A;
      }

    }
  }
}
</style>